import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNav from '@/components/TopNav';

export default function MainLayout() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <TopNav />
      <main className="max-w-[1600px] mx-auto px-3 sm:px-6 py-4 sm:py-6 md:py-8">
        <Outlet />
      </main>
    </div>
  );
}
